export default __webpack_public_path__ + "static/media/shuffle.f40fca5d.mp3";